import { mergeClassNameStrings } from '@consumer-frontend/nc-utils';

import { NcButtonStyledAsLink } from '../NcButtonStyledAsLink';

import '@consumer-bootstrap/brands/netcredit/apply/send-code-link-countdown.scss';

export type NcSendCodeLinkCountdownPropsT = {
  count: number;
  handleSendCode: () => Promise<void>;
};

export type NcSendCodeLinkCountdownT = React.FC<NcSendCodeLinkCountdownPropsT>;

export const NcSendCodeLinkCountdown: NcSendCodeLinkCountdownT = ({
  count,
  handleSendCode,
}) => {
  const link = <NcButtonStyledAsLink onClick={handleSendCode}>Send new code</NcButtonStyledAsLink>;
  const isCounting = count > 0;

  return (
    <div
      className={mergeClassNameStrings(
        'nc-send-code-link-countdown text-center',
        isCounting && 'disabled',
      )}
      data-chromatic="ignore"
    >
      {
        isCounting
          ? <>{link} (Please wait {count} seconds)</>
          : link
      }
    </div>
  );
};
